import { ButtonProtected } from '@components'

import { ReactElement, useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useOpenConnectBankModal } from '@features/bankAccounts/hooks/useOpenConnectBankModal'
import { useBankIntegration } from '@features/openBanking/contexts/bankIntegrationContext'
import { useSyncOpenBankingConnection } from '@features/openBanking/hooks/useSyncOpenBankingConnection'
import { UiSource } from '@features/reconciliation/enums'

import { Scope } from '../../../../enums/scope'
import { TrackingContext } from '../../../../enums/trackingContext'

export const ConnectBankButton = (): ReactElement | null => {
  const { t } = useTranslation()
  const { connectedBankAccountId, isLoading, requiresBankReconnection } = useBankIntegration()
  const { syncOpenBankingAccountConnection } = useSyncOpenBankingConnection()
  const openConnectBankModal = useOpenConnectBankModal()

  const handleConnectBankClick = useCallback(() => {
    if (connectedBankAccountId && requiresBankReconnection) {
      syncOpenBankingAccountConnection(connectedBankAccountId)
    } else {
      openConnectBankModal(UiSource.OldReconView)
    }
  }, [connectedBankAccountId, requiresBankReconnection, syncOpenBankingAccountConnection, openConnectBankModal])

  const buttonText = useMemo(() => {
    if (connectedBankAccountId && requiresBankReconnection) {
      return t('bank_integration.renew_connection')
    }

    return t('bank_integration.connect_bank')
  }, [connectedBankAccountId, requiresBankReconnection, t])

  if (isLoading || (connectedBankAccountId && !requiresBankReconnection) || !connectedBankAccountId) {
    return null
  }

  return (
    <ButtonProtected
      icon="plug"
      onClick={handleConnectBankClick}
      scopes={Scope.BankSyncWrite}
      trackingContext={TrackingContext.BankConnectionsConnectBank}
    >
      {buttonText}
    </ButtonProtected>
  )
}
